<script>

import ScholarshipMeetingApi from "../../Services/Api/MeetingApi/ScholarshipMeetingApi";
import {createHelpers} from "vuex-map-fields";
import {mapActions, mapMutations, mapState} from "vuex";

const {mapFields} = createHelpers({
  getterType: 'scholarship_comment/getPayloadComment',
  mutationType: 'scholarship_comment/updatePayloadComment',
});
export default {
  name: "TheMeetingEditAchievementParametersDialog",

  props: {
    achievement: Object,
    visible: Boolean,
  },

  data() {
    return {
      color: 'teal darken-3',
      parameters: [],
      menuProps: {'content-class': 'rounded-xl', 'offset-y': true},

      achievementTypeId: null,
      achievementKindId: null,
      achievementUnitId: null,
      achievementSubunitId: null,

      loading:false,

      persistentRules: [
        v => !!v || 'Поле не может быть пустым',
      ]
    };
  },

  created() {
    this.getAchievementParameters();
  },

  watch: {

    achievementTypeId(newVal, oldVal) {
      if (!_.isNil(oldVal)) {
        this.achievementKindId = null;
        this.achievementUnitId = null;
        this.achievementSubunitId = null;
      }
    },

    achievementKindId(newVal, oldVal) {
      if (!_.isNil(oldVal)) {
        this.achievementUnitId = null;
        this.achievementSubunitId = null;
      }
    },

    achievementUnitId(newVal, oldVal) {
      if (!_.isNil(oldVal)) {
        this.achievementSubunitId = null;
      }
    },

  },

  computed: {

    show: {
       get() {
        this.setOldAchievementParameters();
        return this.visible
      },
      set(value) {
        if (!value) {
          this.resetPayloadParameters()
          this.resetPayloadComment();
          this.$emit('close')
        }
      }
    },

    ...mapState({
      statement: state => state.scholarship_competition.statement,
    }),

    ...mapFields([
      "comment",
      "comment_type",
      "prtf_achievement_id",
      "payload",
      "scholarship_competition_id",
    ]),

    achievementKinds() {
      if (_.isNil(this.achievementTypeId) || _.isEmpty(this.parameters)) return [];
      return  _.find(this.parameters, type => type.id === this.achievementTypeId).achievement_kinds
    },

    achievementUnits() {
      if (_.isNil(this.achievementKindId) || _.isEmpty(this.achievementKinds)) return [];
      return  _.find(this.achievementKinds, kind => kind.id === this.achievementKindId).achievement_units
    },

    achievementSubunits() {
      if (_.isNil(this.achievementUnitId) || _.isEmpty(this.achievementUnits)) return [];
      return  _.find(this.achievementUnits, unit => unit.id === this.achievementUnitId)?.achievement_subunits || []
    },

    isAchievementCommentPresent() {
      if (_.isEmpty(this.statement) || _.isEmpty(this.achievement)) return false;
      const achievement = _.find(this.statement.achievements, achievement => achievement.id === this.achievement.id);
      return !_.isNil(achievement.comments) && !_.isEmpty(achievement.comments);
    },

  },

  methods: {

    ...mapMutations({
      resetPayloadComment: 'scholarship_comment/resetPayloadComment',
    }),

    ...mapActions({
      getStatements: 'scholarship_competition/getStatements',
      getStatement: 'scholarship_competition/getStatement',
      createComment: "scholarship_comment/createComment",
    }),

    async getAchievementParameters() {
      const response = await ScholarshipMeetingApi.getAchievementParameters();

      if (_.isNil(response)) return null;
      this.parameters = response.data.data
    },

    async createVoteToChangeParametersAchievement() {

      if (!this.$refs.formEditAchievementParameters.validate()) return

      this.loading = true;

      await this.setCommentPayload();
      await this.createComment();
      await Promise.all([this.getStatements(), this.getStatement(this.statement.id)])

      this.loading = false;
      this.show = false;
    },

    setCommentPayload() {
      this.comment = this.setCommentText();
      this.comment_type = 'edit_achievement';
      this.scholarship_competition_id = this.statement.id;
      this.prtf_achievement_id = this.achievement.id;

      this.payload = {
        old_achievement_type: this.achievement.prtf_achievement_type_id,
        old_achievement_kind: this.achievement.prtf_achievement_kind_id,
        old_achievement_unit: this.achievement.unit?.id || null,
        old_achievement_subunit: this.achievement.subunit?.id || null,

        new_achievement_type: this.achievementTypeId,
        new_achievement_kind: this.achievementKindId,
        new_achievement_unit: this.achievementUnitId,
        new_achievement_subunit: this.achievementSubunitId,

        status_resolve: false
      };
    },

    setOldAchievementParameters() {
      this.achievementTypeId = this.achievement.prtf_achievement_type_id;
      this.achievementKindId = this.achievement.prtf_achievement_kind_id;
      this.achievementUnitId = this.achievement.unit?.id || null;
      this.achievementSubunitId = this.achievement.subunit?.id || null;
    },

    setCommentText() {
      const newAchievementType = _.find(this.parameters, type => type.id === this.achievementTypeId).name;
      const newAchievementKind = _.find(this.achievementKinds, kind => kind.id === this.achievementKindId).name;
      const newAchievementUnit = _.find(this.achievementUnits, unit => unit.id === this.achievementUnitId)?.name || '';
      const newAchievementSubunit = _.find(this.achievementSubunits, subunit => subunit.id === this.achievementSubunitId)?.name || '';

      return `
         Предлагается поменять параметры достижения:
         '${this.achievement.prtf_achievement_type_name}', '${this.achievement.prtf_achievement_kind_name}',
         '${this.achievement?.unit?.name || ''}', '${this.achievement?.subunit?.name || ''}'
         на НОВЫЕ параметры:
         '${newAchievementType}', '${newAchievementKind}',
         '${newAchievementUnit}', '${newAchievementSubunit}'
      `
    },

    resetPayloadParameters() {
      this.achievementSubunitId = null;
      this.achievementTypeId = null;
      this.achievementKindId = null;
      this.achievementUnitId = null;
    },

  },

}
</script>

<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="600px"
    content-class="rounded-xl"
  >
    <v-card class="rounded-xl">
      <v-card-title>
        <span class="text-h5">Изменение параметров достижения</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="formEditAchievementParameters">

            <v-select
              label="Тип деятельности"
              v-model="achievementTypeId"
              outlined
              :color="color"
              class="rounded-xl"
              item-value="id"
              item-text="name"
              :items="parameters"
              :menu-props="menuProps"
              dense
              clearable
              :rules="persistentRules"
            >

            </v-select>

            <v-autocomplete
              v-model="achievementKindId"
              :items="achievementKinds"
              label="Вид достижения"
              no-data-text="Виды достижений отсутсвуют"
              clearable
              item-text="name"
              item-value="id"
              outlined
              :color="color"
              class="rounded-xl"
              :menu-props="menuProps"
              dense
              :rules="persistentRules"
            >
              <template #item="data" class="rounded-xl">
                <v-list-item-content style="max-width: 550px">
                  <v-list-item-title class="d-flex text-wrap">{{data.item.name}}</v-list-item-title>
                  <v-list-item-subtitle>{{data.item.description}}</v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>

            <v-select
              v-model="achievementUnitId"
              :items="achievementUnits"
              no-data-text="Критерии отсутсвуют"
              item-text="name"
              item-value="id"
              label="Критерий"
              outlined
              :color="color"
              class="rounded-xl"
              dense
              :menu-props="menuProps"
              clearable
              :rules="persistentRules"
            >
            </v-select>

            <v-expand-transition>
              <v-select
                v-model="achievementSubunitId"
                :items="achievementSubunits"
                v-if="achievementSubunits.length > 0"
                item-text="name"
                item-value="id"
                label="Дополнительный критерий"
                outlined
                :color="color"
                class="rounded-xl"
                dense
                clearable
                :rules="persistentRules"
              >
              </v-select>
            </v-expand-transition>

          </v-form>
        </v-container>
        <small class="font-weight-bold">Внимание: Голосование начнется после подтверждения изменений!</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :color="color"
          outlined
          :loading="loading"
          class="rounded-xl"
          @click="show = false"
        >
          Закрыть
        </v-btn>
        <v-card-text v-if="isAchievementCommentPresent">
          <v-icon small left color="warning">fa-exclamation</v-icon> Запрос на изменение уже существует
        </v-card-text>
        <v-btn
          v-else
          :color="color"
          :loading="loading"
          class="rounded-xl white--text"
          @click="createVoteToChangeParametersAchievement"
        >
          Обновить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>

</style>